import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'NumToThousands',
    standalone: true,
})
export class NumToThousandsPipe implements PipeTransform {
    transform(value: number) {
        return value ? (Math.abs(value) > 999 ? Number(Math.sign(value)) * Number((Math.abs(value) / 1000).toFixed(1)) + 'K' : value) : 0;
    }
}
